import moment from "moment";
import { some } from "lodash";
import { STOP_TYPE as STOP_TYPE_FIELD } from "./";
import { ALL } from "../strings";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: "10:30",
    functionParameters: {
      testFn: (stop) => {
        const duration = moment
          .duration(
            moment(stop.serviceEndTime, "HH:mm").diff(
              moment(stop.serviceStartTime, "HH:mm")
            )
          )
          .asHours();
        return stop.serviceEndTime < "12:00" && duration > 1;
      },
    },
  },
  2: {
    label: "12:00",
    functionParameters: {
      testFn: (stop) => {
        const duration = moment
          .duration(
            moment(stop.serviceEndTime, "HH:mm").diff(
              moment(stop.serviceStartTime, "HH:mm")
            )
          )
          .asHours();
        return (
          stop.serviceEndTime >= "12:00" &&
          stop.serviceEndTime <= "13:00" &&
          duration > 1
        );
      },
    },
  },
  3: {
    label: "Evening",
    functionParameters: { testFn: (stop) => stop.serviceStartTime >= "17:00" },
  },
};

export const STOP_TYPE = {
  title: "Stop Type",
  field: STOP_TYPE_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ route, testFn }) => {
    return some(route.stops || [], testFn);
  },
  volumeOverlayRequired: true,
};
